import React from "react";

const Forget = () => {
  return (
    <div className="d-flex justify-content-center mt-2 login_text ">
      <button className="btn">Forget Password</button>
    </div>
  );
};

export default Forget;
